<template>
    <div class="row">
      <div class="col-12">
        <subscription-end-date-card :children-emails="childrenEmails" :children-count="childrenCount"></subscription-end-date-card>
      </div>
    
      <div class="col-12 col-md-6 col-xl-4" v-for="(plan, index) in plans" :key="index">
        <card class="text-center pb-3">
          <div class="card-body">
            <h4 class="card-title">{{ plan.titleEl }}</h4>
            <h4>{{ plan.price }}&euro;</h4>
            <div>{{ plan.descriptionEl }}</div>
            <div class="text-muted">(ΦΠΑ: {{ Math.round(((plan.price * (vatRegime.vatPercentage/100)) + Number.EPSILON) * 100) / 100 }}&euro;)</div>
          </div>
          <div class="mt-2"><button class="btn btn-success" @click="selectedPlanUid=plan.uid;$modal.show('plan-modal');">Επιλογη</button></div>
        </card>
        <div class="clear"></div>
      </div>
      <div class="col-12 col-md-6 col-xl-4">
        <card class="text-center pb-3">
          <div class="card-body">
            <h4 class="card-title">Ομαδική Συνδρομή Kodiko</h4>
            <h4>??&euro;</h4>
            <div>Ομαδική πρόσβαση σε συλλόγους, υπηρεσίες, εταιρείες, οργανισμούς, κλπ</div>
          </div>
          <div class="p-2" style="background-color:rgb(239, 239, 239);border-radius:3px;">
            <a href="https://www.kodiko.gr/main/group_subscription" target="_blank">Δείτε πληροφορίες εδώ</a>
          </div>
        </card>
        <div class="clear"></div>
      </div>
      <modal name="plan-modal" :draggable="false" height="auto" :scrollable="true" :clickToClose="false">
        <div style="position:relative;" class="p-3">
          <div style="position: absolute; top: 5px; right: 5px;">
            <button class="btn btn-neutral btn-border" @click="$modal.hide('plan-modal')" style="font-size:25px;">&times;</button>
          </div>
          <div>
            <h5 class="card-title mb-4" style="margin-top:5px;">Ελέγξτε πρώτα τα στοιχεία παραστατικού</h5>
          </div>
          <div class="table-responsive">
            <table class="table" style="width:100%">
              <tr><td class="text-right" style="width:50%">Τύπος Παραστατικού</td><td>{{ (invoiceInfo.wantInvoice) ? 'Τιμολόγιο' : 'Απόδειξη' }}</td></tr>
              <tr v-if="invoiceInfo.wantInvoice"><td class="text-right">ΑΦΜ</td><td>{{ invoiceInfo.afm }}</td></tr>
              <tr><td class="text-right">Χώρα</td><td>{{ countries[invoiceInfo.country] }}</td></tr>
              <tr><td class="text-right">Επωνυμία</td><td>{{ invoiceInfo.name }}</td></tr>
              <tr v-if="invoiceInfo.wantInvoice"><td class="text-right">Τηλέφωνο</td><td>{{ invoiceInfo.phone }}</td></tr>
              <tr v-if="invoiceInfo.wantInvoice"><td class="text-right">Διεύθυνση</td><td>{{ invoiceInfo.address }}</td></tr>
              <tr v-if="invoiceInfo.wantInvoice"><td class="text-right">Ταχ. Κώδικας</td><td>{{ invoiceInfo.postalCode }}</td></tr>
              <tr v-if="invoiceInfo.wantInvoice"><td class="text-right">Πόλη</td><td>{{ invoiceInfo.city }}</td></tr>
              <tr v-if="invoiceInfo.wantInvoice && invoiceInfo.country==='GR'"><td class="text-right">Δ.Ο.Υ.</td><td>{{ invoiceInfo.doy }}</td></tr>
              <tr v-if="invoiceInfo.wantInvoice"><td class="text-right">Επάγγελμα/Δραστηριότητα</td><td>{{ invoiceInfo.profession }}</td></tr>
            </table>
          </div>
          <div class="text-center" style="font-size:18px;"><router-link :to="{path:'invoice'}"><u>αλλαγή στοιχείων παραστατικού</u></router-link></div>
          <div class="form-group p-4">
            <div class="">
              <input class="form-check-input" type="checkbox" id="confirm_info" v-model="confirmInfo">
              <label class="form-check-label" for="confirm_info">
                Έχω ελέγξει ότι τα στοιχεία μου είναι αληθή και σωστά
              </label>
            </div>
            <div class="">
              <input class="form-check-input" type="checkbox" id="confirm_terms" v-model="confirmTerms">
              <label class="form-check-label" for="confirm_terms">
                Έχω διαβάσει τους <a href="https://www.kodiko.gr/policy/terms" target="_blank">όρους χρήσης</a> και την <a href="https://www.kodiko.gr/policy/cookies" target="_blank">πολιτική απορρήτου</a> του kodiko.gr και συμφωνώ
              </label>
            </div>
          </div>
          <hr>
          <div class="text-center">
            <button class="btn btn-neutral btn-border" @click="$modal.hide('plan-modal')">Ακυρωση</button>
            <button class="btn btn-success" :disabled="initializingPayment || !confirmInfo || !confirmTerms" @click="selectedPaymentMethod='web_banking';initializePayment();">Συνεχεια<span v-if="initializingPayment">...</span></button>
          </div>
        </div>
    </modal>
    </div>
</template>
<script>
import Api from "../api";
import SubscriptionEndDateCard from "../components/SubscriptionEndDateCard.vue"
export default {
  components: {
    SubscriptionEndDateCard
  },
  data() {
    return {
      fetchingPlans: true,
      plans: [],
      vatRegime: {},
      invoiceInfo: {
        wantInvoice: false,
        afm: "",
        country: null,
        name: "",
        phone: "",
        address: "",
        postalCode: "",
        city: "",
        doy: "",
        profession: ""
      },
      initializingPayment: false,
      selectedPlanUid: null,
      selectedPaymentMethod: null,
      countries: {},
      confirmInfo: false,
      confirmTerms: false,
      childrenCount: 0,
      childrenEmails: []
    };
  },
  mounted() {
    Api.send("GET", "/user/basic_info?with_children=1", {})
      .then((response) => {
        let loggedUser = this.$root.getLoggedUser();
        loggedUser.hasVerifiedEmail = response.data.hasVerifiedEmail;
        loggedUser.assistantQuestionsLeft = response.data.assistantQuestionsLeft;
        loggedUser.subscriptionEndDate = response.data.subscriptionEndDate;
        loggedUser.isSubscriptionExpired = response.data.isSubscriptionExpired;
        loggedUser.subscriptionExpiresSoon = response.data.subscriptionExpiresSoon;
        this.$root.setLoggedUser(loggedUser);
        this.childrenCount = response.data.childrenCount;
        this.childrenEmails = response.data.childrenEmails;
      })
      .catch((err) => {
        this.$root.deleteLoggedUser();
        this.$router.push({name: 'login'});
      })
      .finally(() => {
        this.getPlans();
      });
  },
  methods: {
    getPlans () {
      Api.send("GET", "/plans", {})
        .then((response) => {
          this.vatRegime = response.data.vatRegime;
          this.plans = response.data.plans;
          this.getCountries();
        })
        .catch((err) => {
          this.$root.notifyy('danger', err.msg);
        })
        .finally(() => {
          this.fetchingPlans = false;
        });
    },
    getCountries () {
      Api.send("GET", "/countries/eu", {})
        .then((response) => {
          this.countries = response;
          this.getInvoiceInfo();
        })
        .catch((err) => {
          this.$root.notifyy('danger', err.msg);
        })
        .finally(() => {
          
        });
    },
    getInvoiceInfo () {
      Api.send("GET", "/user/invoice_info", {})
        .then((response) => {
          this.invoiceInfo.wantInvoice = response.data.wantInvoice;
          this.invoiceInfo.afm = response.data.afm;
          this.invoiceInfo.country = response.data.country;
          this.invoiceInfo.name = response.data.name;
          this.invoiceInfo.phone = response.data.phone;
          this.invoiceInfo.address = response.data.address;
          this.invoiceInfo.postalCode = response.data.postalCode;
          this.invoiceInfo.city = response.data.city;
          this.invoiceInfo.doy = response.data.doy;
          this.invoiceInfo.profession = response.data.profession;
        })
        .catch((err) => {
          this.$root.notifyy('danger', err.msg);
        })
        .finally(() => {
          
        });
    },
    initializePayment () {
      this.initializingPayment = true;
      Api.send("POST", "/payments", {
        plan: this.selectedPlanUid,
        payment_method: this.selectedPaymentMethod
      })
      .then((response) => {
        this.$root.notifyy('success', response.msg);
        this.$router.replace({name: 'payment', params: {reference_id: response.data.reference}})
      })
      .catch((err) => {
        this.$root.notifyy('danger', err.msg);
      })
      .finally(() => {
        this.initializingPayment = false;
      });
    }
  },
};
</script>
<style scoped>
.l {
  float: left;
}
.clear {
  clear: both;
}
</style>
